import React from 'react';
import { Link } from 'react-router-dom';
const productLinks = [{
  label: 'Continuous Security Validation',
  to: '/product'
}, {
  label: 'Frontier Gateway',
  to: '/frontier-gateway'
}, {
  label: 'How It Works',
  to: '/how-it-works'
}, {
  label: 'Use Cases',
  to: '/use-cases'
}, {
  label: 'AI Security',
  to: '/ai-security'
}, {
  label: 'Evidence',
  to: '/evidence'
}];
const companyLinks = [{
  label: 'About',
  to: '/about'
}, {
  label: 'Jobs',
  to: '/jobs'
}, {
  label: 'Enterprise',
  to: 'mailto:enterprise@periscan.com'
}];
export function Footer() {
  return <footer className="relative w-full border-t border-white/5 bg-[#050608]" data-id="element-459">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20" data-id="element-460">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20" data-id="element-461">
          {/* Brand */}
          <div className="md:col-span-5" data-id="element-462">
            <Link to="/" aria-label="Periscan — home" className="inline-flex items-center mb-6 group" data-id="element-463">
              {/*
               Official Periscan logo — same source-of-truth asset used in
               the Hero, with the global #periscan-remove-white SVG filter
               (defined in Layout.tsx) dropping the white background to
               transparent. No animated glow here — the footer brand stays
               static and pixel-clean.
               */}
              <img src="https://cdn.magicpatterns.com/uploads/19wZLyvpjSe2tkaaA1WT1m/p_logo_02_(1)_(1).jpg" alt="Periscan" className="h-12 w-auto object-contain transition-opacity group-hover:opacity-80" style={{
              filter: 'url(#periscan-remove-white)'
            }} data-id="element-464" />
            </Link>
            <p className="text-lg text-white/80 mb-3 max-w-sm leading-relaxed font-medium" data-id="element-465">
              The Hacker On Your Side.
            </p>
            <p className="font-mono text-sm text-[#1a8fd4]" data-id="element-466">
              Find the path. Validate the risk. Prove it's fixed.
            </p>
          </div>

          {/* Product */}
          <div className="md:col-span-3 md:col-start-7" data-id="element-467">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-468">
              Product
            </p>
            <ul className="space-y-3" data-id="element-469">
              {productLinks.map(l => <li key={l.label} data-id="element-470">
                  <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors" data-id="element-471">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3" data-id="element-472">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-473">
              Company
            </p>
            <ul className="space-y-3" data-id="element-474">
              {companyLinks.map(l => <li key={l.label} data-id="element-475">
                  <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors" data-id="element-476">
                    {l.label}
                  </Link>
                </li>)}
              <li data-id="element-477">
                <a href="mailto:contact@periscan.com" className="text-sm text-white/70 hover:text-white transition-colors" data-id="element-478">
                  contact@periscan.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-479">
          <div className="flex flex-col gap-1" data-id="element-480">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40" data-id="element-481">
              © {new Date().getFullYear()} Periscan, Inc. All rights reserved.
            </p>
            <p className="text-xs text-white/30" data-id="element-482">Founded 2004. Reborn 2026.</p>
          </div>

          <div className="flex flex-wrap items-center gap-6 text-xs text-white/40" data-id="element-483">
            <Link to="/privacy" className="hover:text-[#1a8fd4] transition-colors" data-id="element-484">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-[#1a8fd4] transition-colors" data-id="element-485">
              Terms
            </Link>
            <a href="#" className="hover:text-[#1a8fd4] transition-colors" data-id="element-486">
              Coming Soon
            </a>
            <a href="/llms" className="font-mono uppercase tracking-widest hover:text-[#1a8fd4] transition-colors" data-id="element-487">
              /llms.txt
            </a>
          </div>
        </div>
      </div>
    </footer>;
}